module.exports = __webpack_public_path__ + "img/yClients.13a12991.png";